import React, { useContext, useEffect, useState } from 'react';
import {
  AspectRatioContainer,
  Image
} from '@volkswagen-onehub/components-core';
import { VehicleContext } from '../../utils/vehicle-context';
import { getLang } from '../../translations';
import { Photo, VehicleData } from '../../types';

export const Jelly = () => {
  const {photos, model_name, year, engine, trim} = useContext(VehicleContext) as VehicleData;
  const lang = getLang();
  const [photo, setPhoto] = useState<Photo | null>(null);
  const [imageDetails, setImageDetails] = useState<string | null>(null);

  useEffect(() => {
    if(!photos) return;
    photos.map(img => {
      if (img.main_photo) {
        setPhoto(img);
      }
    });

  }, [photos]);

  useEffect(() => {
    if(!model_name || !year || !engine || !trim) return;
    const name = year + ' ' + model_name + ' ' + (engine[lang] ? engine[lang] : '') + ' ' + (trim[lang] ? trim[lang] : '');
    setImageDetails(name);
  }, [model_name, year, engine, trim]);

  return (
    <AspectRatioContainer ratio="4:3">
      {photo &&
        <Image
          aria-label={imageDetails ? imageDetails : ''}
          src={photo.url}
          alt={imageDetails ? imageDetails : ''}
          objectFit="contain"
        />
      }
    </AspectRatioContainer>
  );
};
